import { NotifyHelper } from "../../../helpers/toast";
import { eMonThiActionsObj } from "../../action-types/tct/IMonThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const monThiActions = {
    ...generateActions(eMonThiActionsObj, "MON_THI"),
    ...generateActionForKey(eMonThiActionsObj, "MON_THI", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eMonThiActionsObj, "MON_THI", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    // ...generateActionForKey(eMonThiActionsObj, "MON_THI", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    // ...generateActionForKey(eMonThiActionsObj, "MON_THI", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eMonThiActionsObj, "MON_THI", "ADD_MON_THI_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eMonThiActionsObj, "MON_THI", "ADD_MON_THI_ERROR", () => NotifyHelper.Error("Có lỗi xảy ra khi thêm môn thi")),
};
